export const formatterDateTime = (isoString, locale = navigator.language) => {
  const date = new Date(isoString);

  const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
  const optionsDateLong = { day: "2-digit", month: "long", year: "numeric" };
  const optionsTime = { hour: "2-digit", minute: "2-digit", hour12: false };
  const optionsDayLong = { weekday: "long" };
  const optionsDay = { weekday: "short" };
  const optionsMonth = { month: "numeric" };
  const optionsMonthLong = { month: "long" };
  return {
    timeDate: date
      .toLocaleString(locale, { ...optionsDate, ...optionsTime })
      .replace(",", ""),
    date: date.toLocaleDateString(locale, optionsDate),
    timeDateLong: date
      .toLocaleString(locale, { ...optionsDateLong, ...optionsTime })
      .replace(",", ""),
    dateLong: date.toLocaleDateString(locale, optionsDateLong),
    time: date.toLocaleTimeString(locale, optionsTime),
    day: date.toLocaleDateString(locale, { day: "2-digit" }),
    dayShort: date.toLocaleDateString(locale, optionsDay),
    dayLong: date.toLocaleDateString(locale, optionsDayLong),
    Month: date.toLocaleDateString(locale, optionsMonth),
    MonthLong: date.toLocaleDateString(locale, optionsMonthLong),
    year: date.getFullYear().toString(),
    hour: date.getHours().toString(),
    minute: date.getMinutes().toString().padStart(2, "0"),
  };
};
